'use strict';

angular.module('schoolbushubApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('register', {
                parent: 'account',
                isApp: true,
                url: '/register',
                data: {
                    roles: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'app-content@': {
                        templateUrl: 'scripts/app/account/register/register.html',
                        controller: 'RegisterController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        return $translate.refresh();
                    }]
                }
            }).state('registerWithSchoolCode', {
                parent: 'account',
                isApp: true,
                url: '/register/:schoolCode',
                data: {
                    roles: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'app-content@': {
                        controller: 'SchoolCodeController'
                    }
                }
            });
});
